/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './GainLossCell.scss';

import { number, oneOfType, string, bool } from 'prop-types';
import React from 'react';

import { Dollar, Percent } from 'components/shared/Text/Text';
import ValueIndicator from 'components/shared/ValueIndicator/ValueIndicator';

const GainLossCell = ({ amount, percent, showPercent }) => {
  if (amount === '-' || percent === '-') {
    return <td className="gain-loss-cell">-</td>;
  }
  return (
    <td className="gain-loss-cell">
      <span>
        <span>
          <Dollar element="div">{amount}</Dollar>
          {showPercent && (
            <Percent className="e2e-daily-change-percent" element="div">
              {percent}
            </Percent>
          )}
        </span>
        <ValueIndicator value={amount} />
      </span>
    </td>
  );
};

GainLossCell.propTypes = {
  amount: oneOfType([number, string]).isRequired,
  percent: oneOfType([number, string]).isRequired,
  showPercent: bool.isRequired
};

export default GainLossCell;
